import * as React from 'react';

const Loader = () => {
  return (
    <div className="loader">
      <div className="lds-dual-ring" />
    </div>
  );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/modules/Loader/Loader.tsx